<template>
    <div>
        <div
            class="relative"
            :class="aspectRatioClass"
        >
            <img
                class="absolute h-full w-full object-cover"
                :src="link"
                :alt="alt"
            >
        </div>
    </div>
</template>
<script>
export default {
    props: {
        link: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            default: 'foto',
        },
        aspectRatio: {
            type: String,
            default: '2/3',
        }
    },
    data ()
    {
        return {};
    },
    methods: {},
    computed: {
        aspectRatioClass: function()
        {
            return `pb-${ this.aspectRatio }`;
        }
    },
    created () { },
};
</script>